/**
 * 左侧内容
 */
import Chip from 'Chip';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NewsStream } from '@ifeng/news-stream';
import '@ifeng/news-stream/lib/NewsStream/style/news-stream-global.css';
import styles from './index.css';
import ShanklistComponents from '../../../components/shanklistComponents/index';
import FocusImgNews from './focusImgNews';
import { getColumnInfo2 } from '../../../services/api';

class Content extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    constructor(...argu) {
        super(...argu);

        const { newsstream, preloadNewsstream, commonIdArray } = this.props.content;

        this.lastItem = preloadNewsstream ? preloadNewsstream[preloadNewsstream.length - 1] : null;
        this.lastItem = this.lastItem === null && newsstream ? newsstream[newsstream.length - 1] : this.lastItem;

        this.repeatedID = [...commonIdArray];
    }

    // 渲染
    componentsView(mainData) {
        const { noAd } = this.props.content;

        return mainData.map((item, index) => {
            const { chip, data, component, componentOptions } = item;

            if (chip.user && chip.user !== '') {
                return (
                    <Chip key={index} content={data} {...chip}>
                        {React.createElement(ShanklistComponents[component], { componentOptions, noAd })}
                    </Chip>
                );
            } else {
                return React.createElement(ShanklistComponents[component], {
                    key: index,
                    componentOptions,
                    content: data,
                    noAd,
                });
            }
        });
    }
    // 广告数组
    adArr() {
        const { newsStream1Ad, newsStream2Ad } = this.props.content;

        const ad = [];

        if (newsStream1Ad) ad.push(newsStream1Ad);
        if (newsStream2Ad) ad.push(newsStream2Ad);

        return ad;
    }
    // 加载更多
    handleMoreData = async () => {
        const { newsTime, id } = this.lastItem;
        const time = new Date(newsTime).getTime();
        const { columnId, newsStream } = this.props.content;

        const argu = [];

        if (newsStream) argu.push(newsStream.key, newsStream.type);
        else argu.push(columnId);

        const { data } = await getColumnInfo2(id, time, 20, ...argu);

        // 去重
        for (let i = data.newsstream.length - 1; i >= 0; i--) {
            if (!data.newsstream[i].id) continue;

            if (this.repeatedID.includes(data.newsstream[i].id)) {
                data.newsstream.splice(i, 1);
            } else {
                this.repeatedID.push(data.newsstream[i].id);
            }
        }

        this.lastItem = data.newsstream[data.newsstream.length - 1];

        for (let i = 0; i < data.newsstream.length; i++) {
            if (
                data.newsstream[i].searchPath &&
                data.newsstream[i].searchPath.split(' ') &&
                data.newsstream[i].searchPath.split(' ').length > 1
            ) {
                for (let el of data.newsstream[i].searchPath.split(' ')) {
                    if (el.indexOf(columnId) !== -1) {
                        data.newsstream[i].searchPath = el;
                    } else {
                        data.newsstream[i].searchPath = data.newsstream[i].searchPath.split(' ')[0];
                    }
                }
            }
        }

        return {
            data: {
                newsstream: data.newsstream,
                isEnd: data.isEnd,
            },
        };
    };
    render() {
        const { content } = this.props;
        const { newsstream, isEnd, columnId, mainData, commonIdArray, newsStream, allColumnData, articleAd } = content;

        for (let i = 0; i < newsstream.length; i++) {
            if (
                newsstream[i].searchPath &&
                newsstream[i].searchPath.split(' ') &&
                newsstream[i].searchPath.split(' ').length > 1
            ) {
                for (let el of newsstream[i].searchPath.split(' ')) {
                    if (el.indexOf(columnId) !== -1) {
                        newsstream[i].searchPath = el;
                    } else {
                        newsstream[i].searchPath = newsstream[i].searchPath.split(' ')[0];
                    }
                }
            }
        }
        const searchPathMap = {};

        for (let item of allColumnData) {
            searchPathMap[item.searchPath] = item.name;
        }

        const newsStreamProps = {
            content: newsstream,
            columnId: newsStream ? newsStream.key : columnId,
            isEnd,
            isDisplaySource: true,
            repeatedID: commonIdArray,
            ad: this.adArr(),
            searchPathMap,
        };
        let focusImgNews = null;

        if (newsstream && newsstream.length > 3) {
            focusImgNews = { content: newsstream.splice(0, 3), ad: articleAd };
        }

        if (newsStream) newsStreamProps.dataTypeName = newsStream.type;

        return (
            <div className={styles.content}>
                {focusImgNews && focusImgNews.content.length >= 3 ? <FocusImgNews {...focusImgNews} /> : ''}
                {/* 组件 */}
                {this.componentsView(mainData)}
                <NewsStream {...newsStreamProps} handleLoadingDataFunc={this.handleMoreData} />
            </div>
        );
    }
}

export { Content };
export default Content;
